import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useUsersInOrganization = (organizationId, options = {}) => {
  return useQuery(
    ["usersInOrganization", organizationId],
    async () => {
      const result = await authAPI.getUsersInOrganization(organizationId);
      return result;
    },
    {
      enabled: !!organizationId,
      ...options,
    }
  );
};
